import React, { useMemo } from "react";
import "./styles.css";

export interface UserStockItem {
  id: string;
  name?: string;
  selected?: boolean;
  module?: string;
}

export interface StockListProps {
  items: UserStockItem[];
  onSelectionChanged: (idSelectedStock: string) => void;
}

const StockList: React.FC<StockListProps> = ({
  items,
  onSelectionChanged,
}) => {
  const groupedItems = useMemo(() => {
    return items.reduce<Record<string, UserStockItem[]>>((acc, item) => {
      const module = item.module || "Other";

      if (!acc[module]) {
        acc[module] = [];
      }

      acc[module].push(item);
      return acc;
    }, {});
  }, [items]);

  return (
    <div className="stock-list">
      {Object.entries(groupedItems).map(([module, stocks]) => (
        <div key={module} className="stock-module">
          <div className="stock-module-title">{module}</div>

          {stocks.map(stock => (
            <label
              key={stock.id}
              className="stock-item"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <input
                type="checkbox"
                checked={stock.selected}
                onChange={() => onSelectionChanged(stock.id)}
              />
              {stock.name}
            </label>
          ))}
        </div>
      ))}
    </div>
  );
};

export default StockList;